import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';
const GLOBAL = require('../../Globals');

class EditNotes extends Component {
	
	constructor(props){
		super(props);
		this.state = {
			_message : '',
			alertClass :'',
			id : '',
			title : '',
			desc : '',
			attach : '',
			cls : '',
			section : '',
			subject : '',
			posts : [],
			secs : [],
			subj : [],
			data :[],
			_redirect : false
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	/** redirect to Subject **/
	onBack(e){
		
		this.setState({_redirect :true});
	}
	
	onChange(e){
		
		this.setState({[e.target.name]:e.target.value});
		// console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.title && this.state.desc && this.state.cls && this.state.section && this.state.subject){
			$("#showLoader").show();
			console.log(this.state);
			PostData('assignment/updatenotes',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Notes Updated Successfullly',
						alertClass:'alert alert-success'
					});	
					document.getElementById("subform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	componentWillMount(){
		
		this.getdetails();
		this.getclass();
		this.getsection();
		this.getsubject();
	}
	
	getdetails(){
	  $("#showLoader").show();
		GetData('assignment/getnotesbyid/'+this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					title : res[0]['title'],
					desc : res[0]['description'],
					cls : res[0]['class'],
					section : res[0]['section'],
					subject : res[0]['subject'],
					subdate : res[0]['submissiondate']
				});
			}
		});
	}
	
	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Section **/
	getsection(){
		
		GetData('section/getsection').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					secs : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getsubject(){
		
		GetData('subject/getsub').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					subj : responseJson
				});
			}
		});
	}
	
  render() {
	  
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/academic/assignment/addnotes' />);
	}
	
	 var items = this.state.posts;
	  var sec = this.state.secs;
	  var sub = this.state.subj;
	  
	
	  /** get Section By Class **/
	$("#clas").change(function(){
		var fr = $(this).val();
		$("#showLoader").show();
		$.get(GLOBAL.BASE_URL+'section/getsectsbyclass/'+fr,function(o){
			$("#showLoader").hide();
			//$("#acHead").removeClass('chosen_a');
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Section- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.secs)); 	
										
			});
			
		},'json');
	
	});
	
	/** get Subject By Class & Section **/
	$("#secs").change(function(){
		var cr = $("#clas").val();
		var fr = $(this).val();
		$("#showLoader").show();
		$.get(GLOBAL.BASE_URL+'subjectallocation/getsubjectbysec/'+cr+'/'+fr,function(o){
			$("#showLoader").hide();
			//$("#acHead").removeClass('chosen_a');
			$("#sub").html('');
			$('#sub')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Subject- ')); 
			$.each(o,function(key,value){			
				   $('#sub')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.subname)); 	
										
			});	
			//	$("#acHead").addClass('chosen_a');
			
		},'json');
	
	});
	
    return (
		<div>
		  <AcademicPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="6">
					<Card>
					  <form action="" method="post" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Edit Notes</strong>
							<span className="pull-right">
								<Button outline color="primary" onClick={this.onBack}>Back</Button>
							</span>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Title <span className="text-danger">*</span></Label>
								  <Input type="text" name="title" required onChange={this.onChange} value={this.state.title} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Description <span className="text-danger">*</span></Label>
								  <Input type="textarea" name="desc" required onChange={this.onChange} value={this.state.desc} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Attachment </Label>
								  <Input type="file" name="attach"  onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
								  <select name="cls" onChange={this.onChange} className="form-control" id="clas" required value={this.state.cls}> 
									<option value="">Select Class</option>
									{
										items.map(function (item) {
											return <option value={item.id }>{item.class}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Section <span className="text-danger">*</span></Label>
								  <select name="section" onChange={this.onChange} className="form-control" id="secs" required value={this.state.section}>
									<option value="">Select Section</option>
									{
										sec.map(function (item) {
											return <option value={item.id }>{item.section}</option>;
										})
									}		
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Subject <span className="text-danger">*</span></Label>
								  <select name="subject" onChange={this.onChange} className="form-control" id="sub" required value={this.state.subject}>
									<option value="">Select Subject</option>
									{
										sub.map(function (item) {
											return <option value={item.id }>{item.subject}</option>;
										})
									}		
								  </select>
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	);
  }
}

export default EditNotes;


// WEBPACK FOOTER //
// ./src/assignment/Notes/EditNotes.js